<template>
  <RequestRetracted
    request-type="leave"
    :notification="notification"
    :active-notification="activeNotification"
    @show-more-details="showMoreDetails"
  />
</template>

<script>
import Notification from '@/components/notifications/mixins/Notification'
import RequestRetracted from '@/components/notifications/RequestRetracted'

export default {
  name: 'LeaveRetracted',

  components: {
    RequestRetracted,
  },

  mixins: [Notification],

  methods: {
    showMoreDetails() {
      this.$emit('click', this.notification)
    },
  },
}
</script>
